var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag-links"},_vm._l((_vm.categories),function(cat,index){return _c('span',[_c('router-link',{attrs:{"to":`/rubricator/${cat.id}`,"title":`Посмотреть все посты в ${cat.name}`}},[_vm._v(_vm._s(cat.name))]),(index < _vm.categories.length-1)?_c('span',{staticClass:"sep"},[_vm._v("|")]):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }